import { VehicleRegistrationInput } from '@wrisk/ui-components'
import { isEmpty } from 'lodash-es'
import React, { FunctionComponent, useCallback } from 'react'

import { getFormats, useConfig } from '../../../state/configuration'
import { FormInputProps } from '../types'

export const VehicleRegistrationFormInput: FunctionComponent<FormInputProps<string>> = ({
  name,
  value,
  onChange,
  tKey,
  tName,
  t,
}) => {
  const { vehicleRegistration } = useConfig(getFormats)

  const handleChange = useCallback(
    (value: string) => {
      onChange(isEmpty(value) ? undefined : value)
    },
    [onChange],
  )

  return (
    <VehicleRegistrationInput
      name={name}
      onChange={handleChange}
      placeholder={t<string>(tKey(tName, 'placeholder'))}
      value={value}
      format={vehicleRegistration}
    />
  )
}
